import { render, staticRenderFns } from "./pd-lightbox.vue?vue&type=template&id=fafd869a&scoped=true&"
import script from "./pd-lightbox.vue?vue&type=script&lang=js&"
export * from "./pd-lightbox.vue?vue&type=script&lang=js&"
import style0 from "./pd-lightbox.vue?vue&type=style&index=0&id=fafd869a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafd869a",
  null
  
)

export default component.exports